import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MobileShell from "./MobileShell";
import MobileMore from "./MobileMore";
import type { MobileMenuGroup } from "./MobileMore";
import { useLanguage } from "../components/ui/LanguageProvider";
import type { PageMeta } from "../components/layout/PageMetaContext";

/**
 * 모바일 셸 안에 무엇을 그릴지 — 더보기(/crm/more)만 셸 전용 화면이고,
 * 나머지는 전부 PC 와 같은 실제 화면(page = CRMLayout 의 <Outlet/>)이다.
 * 권한 재검사(accessDenied)는 CRMLayout 결과를 그대로 따른다.
 */
export default function MobileApp({
  page,
  pageMeta,
  accessDenied,
  deniedNotice,
  groups,
}: {
  page: React.ReactNode;
  pageMeta: PageMeta | null;
  accessDenied: boolean;
  deniedNotice: React.ReactNode;
  groups: MobileMenuGroup[];
}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  if (pathname === "/crm/more") {
    return <MobileShell title={t("더보기", "More")}><MobileMore groups={groups} /></MobileShell>;
  }

  // 메뉴 화면 아래 상세(/crm/opportunities/:id 등)면 뒤로가기. crumbs 가 3칸 = 상세(CRMLayout pageMeta 규칙).
  const isDetail = (pageMeta?.crumbs?.length ?? 0) > 2 || !pageMeta;
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate("/crm/dashboard"));
  return (
    <MobileShell title={pageMeta?.title || undefined} onBack={isDetail ? back : undefined}>
      {accessDenied ? deniedNotice : page}
    </MobileShell>
  );
}
